// extracted by mini-css-extract-plugin
module.exports = {"search-input":"SearchInput_search-input__4iOow"};